<!-- For Mobile -->
<button class="toggle-btn" (click)="toggleSidebar()">☰</button>

<nav class="sidebar" [class.show]="sidebarOpen">
  <!-- Optional logo image -->
  <div class="sidebar-logo-wrapper">
    <img src="logo.png" alt="Hospital Logo" class="sidebar-logo" />
  </div>

  <h2 class="logo">🩺 OBULE STORE DASHBOARD</h2>
  <ul>
    <li><a routerLink="/pharmacist/dashboard" routerLinkActive="active">Dashboard</a></li>
    <li><a routerLink="/pharmacist/dispensary" routerLinkActive="active">Issue products</a></li>
    <li><a routerLink="/pharmacist/patients" routerLinkActive="active">Patients</a></li>
    <li><a routerLink="/pharmacist/transfers" routerLinkActive="active">Transfer Logs</a></li> <!-- ✅ New menu item -->
    <li><a (click)="confirmLogout()">Logout</a></li>
  </ul>
</nav>
